// extracted by mini-css-extract-plugin
module.exports = {"flight":"flight-1na8M","flight_selected":"flight_selected-3aLPs","price":"price-13Eel","selectedFare":"selectedFare-LG0X4"};